import { render } from "./PostCode.vue?vue&type=template&id=35ec9720&scoped=true"
import script from "./PostCode.vue?vue&type=script&lang=js"
export * from "./PostCode.vue?vue&type=script&lang=js"

import "./PostCode.vue?vue&type=style&index=0&id=35ec9720&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ec9720"]])

export default __exports__